import { Route } from 'vue-router'
import rootStore from '@vue-storefront/core/store'
import config from 'config'
import { currentStoreView } from '@vue-storefront/core/lib/multistore'

export function afterEach(to: Route, from: Route) {
}
